module.exports = ".none-space-top {\n    margin-top: 0;\n    padding-top: 0;\n}\n\n.none-space-bottom {\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n"